<template>
  <VDialogV3
    id="manufacturer-card"
    position="right"
    width="600px"
    height="100vh"
    :entity="localManufacturer"
    :file-entities="fileEntities"
    :context-menu="ManufacturersService.contextMenu"
    :submit-method="submit"
  >
    <section>
      <VInput
        ref="nameInput"
        v-model="localManufacturer.name"
        label="Название производителя"
        layout="vertical"
        :validate-method="validateName"
      />
    </section>
  </VDialogV3>
</template>

<script lang="ts">

import Manufacturer            from '@/domains/Manufacturers/Manufacturer';
import ManufacturersService    from '@/domains/Manufacturers/ManufacturersService';
import EntityPointer           from '@/domains/EntityPointer/EntityPointer';

export default defineComponent({
  name: 'ManufacturerCard',

  props: {
    manufacturer: {
      type:    Manufacturer as PropType<Manufacturer | null>,
      default: null,
    },
    id: {
      type:    Number,
      default: null,
    },
  },

  setup() {
    return {
      ManufacturersService,
    };
  },

  data() {
    return {
      localManufacturer: null as Manufacturer | null,

      /** Сохранённое название — своё же название дублем не считается */
      initialName: null as string | null,
    };
  },

  computed: {
    /** Указатели на сущности, к которым цепляются файлы: только сам производитель. Пустые отсеиваются. */
    fileEntities(): EntityPointer[] {
      return EntityPointer.collect([
        EntityPointer.make('manufacturer', this.localManufacturer?.id, this.localManufacturer?.toString()),
      ]);
    },
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init(): Promise<void> {
      if (this.id) {
        this.localManufacturer = await ManufacturersService.get(this.id);
      }
      else if (this.manufacturer instanceof Manufacturer) {
        this.localManufacturer = this.$core.utils.cloneDeep(this.manufacturer);
      }
      else {
        this.localManufacturer = new Manufacturer();
      }

      this.initialName = this.localManufacturer.name;
    },

    async submit(): Promise<boolean> {
      if (this.localManufacturer!.isExisting === true) {
        return await ManufacturersService.update(this.localManufacturer!);
      }
      else {
        return await ManufacturersService.add(this.localManufacturer!);
      }
    },

    validateName(value: string): string | null | Promise<string | null> {
      if (typeof value !== 'string' || value.length === 0) { return 'Поле обязательно'; }
      if (value.length > 200) { return 'Максимальная длина поля 200 символов'; }
      if (value === this.initialName) { return null; }

      return ManufacturersService.getList({ name: value }).then(list => {
        return list.length > 0 ? 'Ошибка уникальности. Данное название уже существует' : null;
      });
    },
  },
});
</script>
